import { ManipulationType } from 'generated/graphql';
import { EditedRecord } from '../store/types';
import { getReasonPredictions } from './getReasonPredictions';
import { getTrackedKeywordPredictions } from './getTrackedKeywordPredictions';

export const getDeletedEditPredictionLabelIDs = (
  editedRecord?: EditedRecord | undefined,
) => {
  const deletedReasonsLabelIDs = getReasonPredictions(editedRecord)
    ?.filter((label) => label.manipulationType === ManipulationType.Remove)
    ?.map((label) => label.prediction.id);

  const deletedEntityLabelIDs = getTrackedKeywordPredictions(editedRecord)
    ?.filter((label) => label.manipulationType === ManipulationType.Remove)
    ?.map((label) => label.prediction.id);

  return [...(deletedReasonsLabelIDs ?? []), ...(deletedEntityLabelIDs ?? [])];
};
